module.exports = __webpack_public_path__ + "img/2.8e72a889.png";